import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-banners',
  standalone: false,
  templateUrl: './banners.component.html',
  styleUrl: './banners.component.scss'
})
export class BannersComponent implements OnInit {
  @Input() secaoUrl!: any;
  @Input() urlDesktop!: any;
  @Input() urlMobile!: any;

  capas: any;
  public loading = false;
  constructor(
    public apiService: ApiService,
  ) {}

  ngOnInit(): void {
    this.initialize();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['secaoUrl'] || changes['urlDesktop'] || changes['urlMobile']) {
      this.initialize();
    }
  }

  private initialize(): void {
    this.loading = true;
    this.apiService.loadCapas().subscribe((data) => {
      if(this.secaoUrl && this.secaoUrl !== 'linhas'){
        this.capas = data.find((secao) => {
          return secao.secaoUrl == this.secaoUrl;
        });
      } else{
            let capaTemp = {
              desktopUrl: this.urlDesktop,
              mobileUrl: this.urlMobile
            }
            this.capas = capaTemp;
      }
      this.loading = false;
    });
  }

}
